import React from 'react';
import { ExpandChevron } from './TableRowExpansion';
import PoOrderTopLine from './PoOrderTopLine';
import OrderAttachmentMarker from './OrderAttachmentMarker';
import OrderDeliveryPaperworkMarker from './OrderDeliveryPaperworkMarker';
import { COMPLETED_ORDER_NUMBER_CLASS } from '../constants/rowStyles';

/**
 * THE phone (below `md`) PO/Order first cell — ONE cell for every phone
 * table: My Orders, Dept Orders, To Approve (`OrderMobileTableRow`), Dept
 * Hires and My Hires (`HireMobileTableRow`). Owner 2026-10-03: *"The first
 * column order id/PO is different on My Orders and My Hires. This should be
 * shared across multiple pages — unify"*. Width: `PHONE_PO_ORDER_COLUMN` in
 * `sharedTableColumns.js` — never a per-page override.
 *
 * Chevron · `PoOrderTopLine` (only when there is a PO) · the grey order
 * number with the paperwork + paperclip markers (each renders nothing when
 * absent). Same padding, font and colour on every page.
 *
 * 🔀 NOT A LINK on any page (owner, 2026-10-03): a tap anywhere in the cell
 * reaches the row's own expand toggle. The hires' way to the order is the
 * expanded order's Actions ▾ › View in orders (`hires/hireOrderMenu.js`).
 * `className` adds to the `<td>` (the hires overdue rule rides it).
 */
export const PHONE_PO_CELL_CLASS = 'pl-0.5 pr-0 py-2 h-11 align-middle text-sm text-gray-700 dark:text-gray-300';

export default function PhonePoOrderCell({
  showChevron = true,
  expanded,
  actionable,
  chevronTestId,
  chevronState,
  poNumber,
  poTestId,
  orderNumber,
  complete = false,
  hasDeliveryPaperwork,
  deliveryFiles,
  fileCount,
  attachmentFiles,
  orderTestId,
  testId,
  innerTestId,
  className = '',
}) {
  const tone = complete ? COMPLETED_ORDER_NUMBER_CLASS : 'text-gray-500 dark:text-gray-400';
  return (
    <td
      data-col="po_number"
      className={className ? `${PHONE_PO_CELL_CLASS} ${className}` : PHONE_PO_CELL_CLASS}
      data-testid={testId}
      title={chevronState || undefined}
    >
      <div className="flex items-center gap-0.5 min-w-0" data-testid={innerTestId}>
        {showChevron ? (
          <span className="shrink-0">
            <ExpandChevron expanded={expanded} actionable={actionable} testId={chevronTestId} />
          </span>
        ) : null}
        {chevronState && <span className="sr-only">{chevronState}</span>}
        <div className="min-w-0">
          <PoOrderTopLine
            poNumber={poNumber}
            testId={poTestId}
            className={complete ? COMPLETED_ORDER_NUMBER_CLASS : ''}
          />
          {orderNumber ? (
            <div className={`text-xs font-semibold truncate leading-tight ${tone}`} title={orderNumber} data-testid={orderTestId}>
              {orderNumber}
              {/* Nested INSIDE the number: each marker carries its own `title`. */}
              <OrderDeliveryPaperworkMarker present={hasDeliveryPaperwork} files={deliveryFiles} className="ml-0.5" />
              <OrderAttachmentMarker count={fileCount} files={attachmentFiles} className="ml-0.5" />
            </div>
          ) : (
            <span className="text-gray-400 dark:text-gray-500">-</span>
          )}
        </div>
      </div>
    </td>
  );
}
